import { Field, Int, ObjectType } from '@nestjs/graphql'
import { UserDto } from '../user'
import { CancellationCampaignDto } from './cancellationCampaign.dto'

/**
 * One subscription cancellation. A row per cancellation, kept for good: coming back stamps
 * `resubscribedDate` on it instead of erasing it, which is what the user's own `cancelReason` fields
 * used to do. [sc-28213]
 */
@ObjectType()
export class CancellationDto {
  @Field(t => Int)
  id!: number

  @Field(t => Int)
  userId!: number

  /** Only `id`, `name`, `emailAddress` and `image` are filled in. */
  @Field(t => UserDto, { nullable: true })
  user?: UserDto

  /** `SUBSCRIPTIONS.CANCELLATION_SOURCE`. */
  @Field(t => Int)
  source!: number

  /** A `SUBSCRIPTIONS.CANCELLATION_TYPE` reason, or a `SUBSCRIPTIONS.CANCELLATION_CATEGORY`. */
  @Field(t => Int)
  reason!: number

  /** What the author wrote, or the comment left by whoever cancelled it from the Stripe dashboard. */
  @Field({ nullable: true })
  reasonDescription?: string

  /** When the cancellation was asked for, not when the paid period ran out. */
  @Field()
  cancelledDate!: Date

  /** When the paid access ends, or ended. */
  @Field({ nullable: true })
  endDate?: Date

  @Field({ nullable: true })
  resubscribedDate?: Date

  /** The same subscription was un-cancelled before it ran out, rather than a new one started. */
  @Field()
  reactivated!: boolean

  /** Months of this subscription that were paid for. */
  @Field(t => Int, { nullable: true })
  monthsPaid?: number

  /** Stripe's `cancellation_details.reason`: cancellation_requested, payment_failed or payment_disputed. */
  @Field({ nullable: true })
  stripeCancellationReason?: string

  /**
   * Stripe's detail behind that reason: the decline code of the failed payment (`expired_card`,
   * `insufficient_funds`, ...), or the feedback picked when it was cancelled from the dashboard.
   */
  @Field({ nullable: true })
  stripeDetail?: string

  /** Up to three, newest first. */
  @Field(t => [CancellationCampaignDto])
  campaigns!: CancellationCampaignDto[]
}
